// src/components/LegalNotice.js

import React from 'react';

// Le composant reçoit une fonction "onClose" pour pouvoir être fermé
const LegalNotice = ({ onClose }) => {
    return (
        <div className="legal-notice-overlay" onClick={onClose}>
            <div className="legal-notice-content" onClick={(e) => e.stopPropagation()}>
                <button className="legal-notice-close-btn" onClick={onClose}>Fermer</button>
                
                <h2>Mentions Légales</h2>

                <p>Conformément aux dispositions des articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'économie numérique (LCEN), il est porté à la connaissance des utilisateurs et visiteurs du site les présentes mentions légales.</p>

                <h3>1. Éditeur du site</h3>
                <p>
                    <strong>Dénomination sociale :</strong> Jean-Christophe WOLFERSPERGER "Entrepreneur Individuel"<br/>
                    <strong>Nom commercial :</strong> TechniServices<br/>
                    <strong>Siège social :</strong> 70 Chemin Dassy - 97430 Le Tampon - La Réunion<br/>
                    <strong>Téléphone :</strong> 06-92-14-28-03<br/>
                    <strong>Adresse e-mail :</strong> contact.techniservices974@gmail.com
                </p>
                <p>
                    <strong>Immatriculation :</strong>
                </p>
                <ul>
                    <li>Numéro SIREN : 917 451 593</li>
                    <li>Numéro SIRET : 917 451 593 00011</li>
                    <li>Immatriculé au RM (Répertoire des Métiers) de Saint-Pierre</li>
                </ul>
                <p><strong>Statut TVA :</strong> TVA non applicable, art. 293 B du CGI.</p>

                <h3>2. Responsable de la publication</h3>
                <p>Le responsable de la publication est : Jean-Christophe WOLFERSPERGER. Il peut être contacté à l'adresse e-mail : contact.techniservices974@gmail.com</p>

                <h3>3. Hébergement du site</h3>
                <p>
                    Le site est hébergé par Google.<br/>
                    <strong>Nom de l'hébergeur :</strong> Google Ireland Limited<br/>
                    <strong>Adresse :</strong> Gordon House, Barrow Street, Dublin 4, Irlande<br/>
                    <strong>Site web :</strong> cloud.google.com
                </p>

                <h3>4. Propriété intellectuelle</h3>
                <p>L'ensemble de ce site (contenus, textes, images, vidéos, logos) constitue une œuvre protégée par la législation en vigueur sur la propriété intellectuelle. Sauf autorisation préalable et écrite de Jean-Christophe WOLFERSPERGER EI, toute reproduction, représentation, adaptation, traduction et/ou modification, partielle ou intégrale, ou transfert sur un autre site est strictement interdit.</p>

                <h3>5. Protection des données personnelles (RGPD)</h3>
                <p>L'utilisateur est informé que les informations personnelles recueillies (via le formulaire de contact, de demande de devis, etc.) sont nécessaires au traitement de sa demande. Ces données sont destinées exclusivement à TechniServices (Jean-Christophe WOLFERSPERGER EI) et ne seront pas transmises à des tiers.</p>
                <p>Conformément au Règlement (UE) 2016/679 (RGPD) et à la loi "Informatique et Libertés" du 6 janvier 1978 modifiée, vous disposez d'un droit d'accès, de rectification, d'opposition, de limitation et de suppression des données vous concernant. Pour exercer ce droit, veuillez contacter le responsable de la publication.</p>

                <h3>6. Cookies</h3>
                <p>Le site peut être amené à utiliser des cookies pour assurer son bon fonctionnement et, le cas échéant, pour mesurer l'audience. L'utilisateur sera informé via un bandeau cookie lors de sa première visite.</p>
                <p>Ce site utilise Google Analytics, un service d'analyse de site internet fourni par Google, pour nous aider à comprendre comment les visiteurs interagissent avec le site. Les données collectées sont anonymes.</p>

                <h3>7. Médiation de la consommation</h3>
                <p>Conformément à l'article L. 612-1 du Code de la consommation, en cas de litige, le consommateur est informé qu'il a la possibilité de saisir un médiateur de la consommation.</p>

                <h3>8. Droit applicable</h3>
                <p>Le présent site est soumis au droit français.</p>
            </div>
        </div>
    );
};

export default LegalNotice;